import React from 'react';
import Modal from '../../../../../../../components/Modal';
import Table from '../../../../../../../components/table/Table';
import columns from './columns';
import './AccountUserDetailCartLogModal.scss';

const AccountUserDetailCartLogModal = (props) => {
  const { isOpen, closeModal, list, filterOption, sortOption, getList } = props;

  return (
    <Modal
      title="유저 장바구니 타임라인 리스트"
      isOpen={isOpen}
      width={1400}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="account-user-detail-cart-timeline-modal">
        <Table
          data={list}
          isStriped={true}
          emptyText="요청하신 검색 필터로 검색된 장바구니 타임라인 리스트가 없습니다."
          filterOption={filterOption}
          sortOption={sortOption}
          getList={getList}
          columns={(utils) => columns(utils)}
        />
      </div>
    </Modal>
  );
};

export default AccountUserDetailCartLogModal;
